var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17C8.67265 16.5774 9.16229 16.244 9.6906 16M15.75 17C15.3274 16.5774 14.8377 16.244 14.3094 16",
    stroke: "#EE3D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14C17.4308 13.0692 16.2435 12.4025 15 12M5.5 14C6.59299 13.1038 7.778 12.4524 9 12.046",
    stroke: "#EE3D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C3.92227 9.37677 5.94206 8.13527 8 7.50012M22 10.9999C20.0778 9.37672 18.0579 8.13526 16 7.50012",
    stroke: "#EE3D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H12.0118",
    stroke: "#EE3D5D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5864 4.32708C12.6577 3.89098 11.3422 3.89096 10.4136 4.32708C10.0852 4.48128 9.95517 4.84472 10.0135 5.19151L12 17L13.9865 5.19153C14.0448 4.84473 13.9148 4.48128 13.5864 4.32708Z",
    stroke: "#EE3D5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkeError);
export default __webpack_public_path__ + "static/media/networkeError.d5c7bb4541984ad77a2d3f1535675030.svg";
export { ForwardRef as ReactComponent };